import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const requiredConfigKeys = [
  'apiKey',
  'authDomain',
  'projectId',
  'storageBucket',
  'messagingSenderId',
  'appId',
];
const missingConfigKeys = requiredConfigKeys.filter((key) => !firebaseConfig[key]);

// The marketing page can render without Firebase, but authenticated data
// screens must fail clearly if deployment configuration is incomplete.
export const firebaseConfigError = missingConfigKeys.length > 0
  ? `Firebase is not configured. Missing: ${missingConfigKeys.map((key) => `REACT_APP_FIREBASE_${key.replace(/[A-Z]/g, (letter) => `_${letter}`).toUpperCase()}`).join(', ')}`
  : null;

// Initialize Firebase only when the complete client configuration exists.
export const app = firebaseConfigError ? null : initializeApp(firebaseConfig);

// Initialize Firestore and Storage
export const db = app ? getFirestore(app) : null;
export const storage = app ? getStorage(app) : null;
export default app;
